export interface Theme {
  readonly name: string;
  readonly font: string;
  readonly bgPanel: string;
  readonly bgPanelSolid: string;
  readonly border: string;
  readonly text: string;
  readonly textDim: string;
  readonly accent: string;
  readonly accent2: string;
  readonly radius: string;
  readonly pad: string;
  readonly shadow: string;
  readonly bg3D: string;
  readonly letterSpacing: string;
  readonly headerWeight: number;
  readonly rule: string;
  readonly key: string;
}

export const themes: Record<string, Theme> = {
  engineering: {
    name: 'Engineering',
    font: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, Consolas, monospace',
    bgPanel: 'rgba(8,11,17,.78)',
    bgPanelSolid: '#0c1118',
    border: 'rgba(120,160,210,.18)',
    text: '#cfdcec',
    textDim: 'rgba(207,220,236,.55)',
    accent: '#4cc9f0',
    accent2: '#6ce0c0',
    radius: '6px',
    pad: '10px 12px',
    shadow: '0 1px 0 rgba(255,255,255,.04) inset, 0 8px 24px rgba(0,0,0,.4)',
    bg3D: '#06080d',
    letterSpacing: '0.02em',
    headerWeight: 600,
    rule: 'rgba(120,160,210,.12)',
    key: 'engineering',
  },
};

export function resolveTheme(t?: string | Theme): Theme {
  if (!t) return themes.engineering;
  if (typeof t === 'string') return themes[t] ?? themes.engineering;
  return { ...themes.engineering, ...t };
}

export function panelStyle(T: Theme, extra: React.CSSProperties = {}): React.CSSProperties {
  return {
    background: T.bgPanel,
    color: T.text,
    font: `12px ${T.font}`,
    border: `1px solid ${T.border}`,
    borderRadius: T.radius,
    backdropFilter: 'blur(14px) saturate(140%)',
    WebkitBackdropFilter: 'blur(14px) saturate(140%)',
    boxShadow: T.shadow,
    letterSpacing: T.letterSpacing,
    ...extra,
  };
}

export function fmtBytes(n: number): string {
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + ' MB';
  return (n / 1024 / 1024 / 1024).toFixed(2) + ' GB';
}

export const LABEL_COLORS: Record<string, string> = {
  Car: '#4cc9f0',
  'Pickup Truck': '#f72585',
  Pedestrian: '#fee440',
  Motorcycle: '#80ed99',
  'Semi-truck': '#ff8500',
  Cones: '#ffba08',
  'Construction Signs': '#c77dff',
  Signs: '#c77dff',
  'Other Vehicle - Uncommon': '#a0a0a0',
  'Other Vehicle - Construction Vehicle': '#ff8500',
  'Personal Mobility Device': '#80ed99',
  'Towed Object': '#a0a0a0',
};

export const RAMPS: Record<string, string> = {
  inferno: 'linear-gradient(90deg,#000004,#420a68,#932667,#dd513a,#fca50a,#fcffa4)',
};
